export default __webpack_public_path__ + "static/1032-89eb57f5c0ff613c681e0691f1dd2dd8.gif";